'use client';

import { __resetStyles, mergeClasses } from "@griffel/react";
import { typographyStyles } from "@fluentui/react-theme";
export const messageBarTitleClassNames = {
  root: 'fui-MessageBarTitle'
};
/**
 * Styles for the root slot
 */
const useRootBaseStyles = /*#__PURE__*/__resetStyles("r168xkm9", null, [".r168xkm9{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase300);}", ".r168xkm9::after{content:\" \";}"]);
/**
 * Apply styling to the MessageBarTitle slots based on the state
 */
export const useMessageBarTitleStyles_unstable = state => {
  const rootBaseStyles = useRootBaseStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(messageBarTitleClassNames.root, rootBaseStyles, state.root.className);
  return state;
};